import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Output() searchClicked = new EventEmitter<void>();
  @Output() languageChanged = new EventEmitter<string>();

  availableLanguages = [
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' }
  ];

  constructor(public translateService: TranslateService) {}

  onSearchClick(): void {
    this.searchClicked.emit();
  }

  onLanguageSelect(langCode: string, event: Event): void {
    event.preventDefault(); // Prevent default link behavior
    if (langCode !== this.translateService.currentLang) {
      this.languageChanged.emit(langCode);
    }
  }
  
  isCurrentLanguage(langCode: string): boolean {
    return this.translateService.currentLang === langCode;
  }
}